import { createContext } from "react"

export const BreadcrumbsContext = createContext<
  Queries.BreadcrumbsItemFieldsFragment[]
>([])
